import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import update from 'react-addons-update';
import {push} from 'react-router-redux';


import {request} from '../../containers/actions';
import * as styles from '../../styles';
import {clearSelection} from '../../paginator/actions';
import PaginatedMarkers from '../markers/component';

export default class Markers extends React.PureComponent {
    static contextTypes = {
        store: PropTypes.object,
    }

    state = {
        classId: '_' + window.uuidv4(),
        questionMarkers: {},
        selectedQuestions: [],
    };

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.mounted = true;
        this.fetch.bind(this)();
    }

    componentWillUnmount() {
        this.mounted = false;
    }

    async fetch() {
        let url = `/examination/${this.props.params.id}/?markers`;
        const response = await this.context.store.dispatch(request(url));
        if (!this.mounted)
            return;
        this.setState({
            id: response.id,
            questionMarkers: _.mapKeys(response.questions, question => question.id),
        });
    }

    async save() {
        try {
            const id = this.state.id;
            const payload = {
                id,
                questions: _.map(
                    this.state.questionMarkers,
                    item => ({id: item.id, markers: _.map(item.markers, marker => ({id: marker.id}))}),
                ),
            };
            await this.context.store.dispatch(request({
                path: `/examination/${id}/?markers`,
                body: payload,
                method: 'PATCH',
            }));
            return true;
        }
        catch (exception) {
            console.error(exception);
            return false;
        }
    }

    render() {
        const actions = [];
        if (_.size(this.props.markers.selected) > 0) {
            actions.push({
                label: _.size(this.props.markers.selected) > 1
                    ? window.gettext('Set Markers')
                    : window.gettext('Set Marker'),
                action: (() => {
                    let state = this.state;
                    _.forEach(
                        this.state.selectedQuestions,
                        id => {
                            const items = _.filter(
                                _.values(this.props.markers.selected),
                                item => !_.some(
                                    this.state.questionMarkers[id].markers,
                                    marker => marker.id === item.id,
                                ),
                            );
                            state = update(
                                state,
                                {questionMarkers: {[id]: {markers: {$push: items}}}},
                            );
                        },
                    );
                    this.context.store.dispatch(clearSelection(this.props.markers.markers.elementId));
                    this.setState(state);
                    this.setState({selectedQuestions: []});
                }),
            });
        }
        return <span>
            <div
                style={{
                    float: 'right',
                    width: '50em',
                }}>
                <PaginatedMarkers
                    {...this.props.markers}
                    readonly
                    pageSize={16}
                    selectable
                    actions={actions}
                />
            </div>
            <div
                style={{
                    float: 'right',
                    marginRight: '2em',
                    width: 'calc(100% - 52em)',
                    backgroundColor: 'white',
                }}>
                <div
                    style={{
                        fontSize: '2.5em',
                        color: '#5e5e5e',
                    }}>
                    {window.gettext('Questions')}
                </div>
                <button
                    key='close'
                    style={{...styles.button, float: 'left', marginRight: '.5em'}}
                    onClick={() => {
                        if (!window.confirm(window.gettext('Are you sure you' +
                            ' wanna cancel editing this' +
                            ' examination? Changes will be lost')))
                            return;
                        this.context.store.dispatch(push(
                            '/examinations/',
                        ));
                    }}>
                    {window.gettext('Close')}
                </button>
                <button
                    key='save'
                    style={{...styles.defaultButton, float: 'left', marginRight: '.5em'}}
                    onClick={async () => {
                        if (!window.confirm(window.gettext('Are you sure you wanna overwrite this examination?')))
                            return;
                        if (!(await this.save.bind(this)())) {
                            alert(window.gettext('Failed to save'));
                        }
                    }}>
                    {window.gettext('Apply')}
                </button>
                <button
                    key='save_and_close'
                    style={{...styles.button, float: 'left', marginRight: '.5em'}}
                    onClick={async () => {
                        if (!window.confirm(window.gettext('Are you sure you wanna overwrite this examination?')))
                            return;
                        if (await this.save.bind(this)()) {
                            this.context.store.dispatch(
                                push('/examinations/'),
                            );
                        }
                        else {
                            alert(window.gettext('Failed to save'));
                        }
                    }}>
                    {window.gettext('Save')}
                </button>
                <div>
                    {_.map(
                        _.map(
                            this.props.main.selectedQuestions,
                            (id, index) => ({
                                ...this.props.main.questions[id],
                                index,
                            }),
                        ),
                        item => <div
                            key={item.id}
                            style={{
                                position: 'relative',
                                display: 'inline-block',
                                width: 'calc(100% - .5em)',
                                margin: '.25em',
                                padding: '.25em',
                                color: _.includes(this.state.selectedQuestions, item.id)
                                    ? styles.fourthColor
                                    : undefined,
                                border: '.0625em solid black',
                            }}
                            onClick={() => _.includes(this.state.selectedQuestions, item.id)
                                ? this.setState(update(this.state, {selectedQuestions: {
                                    $splice: [[this.state.selectedQuestions.indexOf(item.id), 1]],
                                }}))
                                : this.setState(update(this.state, {selectedQuestions: {$push: [item.id]}}))
                            }>
                            {(item.index + 1).persian()}.
                            <div>
                                {(
                                    this.state.questionMarkers[item.id] &&
                                    this.state.questionMarkers[item.id].markers.length > 0
                                )
                                    ? _.map(this.state.questionMarkers[item.id].markers, marker => <div
                                        key={marker.id}
                                        style={{
                                            margin: '.2em',
                                            padding: '.5em',
                                            fontSize: '.6em',
                                            float: 'right',
                                            backgroundColor: '#a9b9e0',
                                            borderRadius: '.8em',
                                            color: 'initial',
                                        }}>
                                        <i className='fa-times' onClick={event => {
                                            event.stopPropagation();
                                            this.setState(update(this.state, {
                                                questionMarkers: {[item.id]: {markers: {
                                                    $splice: [[_.findIndex(
                                                        this.state.questionMarkers[item.id].markers,
                                                        item => item.id === marker.id,
                                                    ), 1]],
                                                }}},
                                            }));
                                        }}></i>
                                        &nbsp;
                                        {marker.firstname} {marker.lastname}
                                    </div>)
                                    : <span
                                        style={{
                                            color: _.includes(this.state.selectedQuestions, item.id)
                                                ? _.includes(this.state.selectedQuestions, item.id)
                                                : '#9a9a9a',
                                        }}>
                                        {window.gettext('No marker has beend set for this question.')}
                                    </span>
                                }
                            </div>
                        </div>,
                    )}
                </div>
            </div>
        </span>;
    }
}
